import React from 'react';
import { Amount, Box, Text } from '@razorpay/blade/components';

export const FBPAmountDetailsCard = ({
  title,
  amount,
}: {
  title: string;
  amount: number | string;
}) => {
  return (
    <Box
      borderRadius={'medium'}
      borderColor={'surface.border.gray.muted'}
      padding={'spacing.7'}
      borderWidth={'thin'}>
      <Text size="medium" color="surface.text.gray.muted">
        {title}
      </Text>
      <Amount value={Number(amount)} size="large" />
    </Box>
  );
};
